import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {MercadoriasColoracaoModel} from "./mercadorias-coloracao.model";
import {MercadoriasColoracaoService} from "./mercadorias-coloracao.service";


@Component({
  selector: 'app-mercadorias-coloracao-form',
  templateUrl: './mercadorias-coloracao-form.component.html'
})
export class MercadoriasColoracaoFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  coloracao: MercadoriasColoracaoModel = new MercadoriasColoracaoModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasColoracaoService: MercadoriasColoracaoService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_coloracao: [],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    this.route.params.subscribe(params => {
      let id = params['id_coloracao'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarColoracao');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarColoracao') : this.func.traduzir('front.cadastrarNovaColoracao');
      }

      if (!id) {
        return;
      }

      this.mercadoriasColoracaoService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarColoracao')+': '+json.Payload[0].nome_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarColoracao') + ': ' + json.Payload[0].nome_pt;
            }
            this.coloracao = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,

    values = this.form.value;

    if (values.id_coloracao) {
      result = this.mercadoriasColoracaoService.editar(values, values.id_coloracao);
    } else {
      result = this.mercadoriasColoracaoService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'mercadorias', 'coloracao']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-coloracao/mercadorias-coloracao-form.component.ts